import FileUpload from './FileUpload';

export default class Portrait {
    id: string | null = null;

    public get = () => {
        const storeStr = `portrait.${this.id}`;

        return new Promise((resolve, reject) => {
            let base64Image = localStorage.getItem(storeStr);
            if (base64Image) {
                resolve(base64Image);
            } else {
                if (!this.id) {
                    reject(false);
                } else {
                    let file = new FileUpload();
                    file.id = this.id;
                    const { promise } = file.download();

                    promise
                        .then(result => {
                            if (result) {
                                let base64Image = result.contentBase64();
                                localStorage.setItem(storeStr, base64Image);
                                resolve(base64Image);
                            } else {
                                localStorage.removeItem(storeStr);
                                reject(false);
                            }
                        })
                        .catch(error => {
                            localStorage.removeItem(storeStr);
                            reject(false);
                        });
                }
            }
        });
    };
}
